import { render, staticRenderFns } from "./filtered-orders.vue?vue&type=template&id=7f84f8c8"
import script from "./filtered-orders.vue?vue&type=script&lang=js"
export * from "./filtered-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports